export default {
    methods: {
        buildReferralMatchData(referral, userId) {
            return {
                userId: userId,
                searchBy: 'zipcode',
                zip: referral.practiceLocation.zip,
                insurancePlanId: referral.insurancePlan.id,
                specialityId: referral.speciality.id,
                fromReferralId: referral.id,
            }
        },

        goToMatchResultsPage(referral, searchData) {
            this.$router.push({
                name: 'referrals.new.results',
                query: searchData,
                params: {
                    existingReferral: referral,
                },
            })
        },

        goToMatchSearchPage(referral, userId) {
            this.$router.push({
                name: 'referrals.new',
                params: {
                    prefillData: this.buildReferralMatchData(referral, userId),
                    existingReferral: referral,
                },
            })
        },
    },
}
